<template>
    <page :busy="busy">
        <div v-if="!showTable">
            <b-button @click="goBack" variant="primary" class="mx-1"> View Details </b-button>
            <vue-apex-charts type="pie" :options="options" :series="series" width="100%" height="400" />
        </div>
        <grid
            v-else
            ref="grid"
            :column-defs="columnDefs"
            :fetch-callback="fetchCallback"
            :is-auto-width="true"
            :getRowStyle="rowStyle"
            :isSearch="true"
            :buttonToolbarClass="['align-items-start flex-md-nowrap']"
            :defaultSort="sort"
            :defaultDesc="true"
            :pinnedBottomRowData="pinnedBottomRowData"
            class="h-100"
        >
            <b-button v-if="false" @click="goBack" variant="primary" class="mr-1"> View Chart </b-button>
            <responsive-dropdown variant="primary" :items="filterDropdown" :icon="['fas', 'filter']">{{
                filterDropdownLabel
            }}</responsive-dropdown>
            <responsive-dropdown variant="primary" :items="msgTypeDropdown" :icon="['fas', 'filter']">{{
                msgTypeDropdownLabel
            }}</responsive-dropdown>

            <div class="merge-source-wrapper mb-0 subscribers-wrapper d-none d-lg-flex mr-1">
                <form-input
                    id="source"
                    @input="(value) => searchSubscribers(value)"
                    :value="subscriberSearch"
                    placeholder="Search by subscriber"
                    autocomplete="off"
                    class="w-100"
                />
                <div class="merge-guests-wrapper subscribers-list-wrapper" v-if="!!subscriberSearch && busy">
                    <div class="guest-item p-2 d-flex align-items-center justify-content-center">
                        <b-spinner variant="primary" :small="true" />
                    </div>
                </div>
                <div
                    class="merge-guests-wrapper subscribers-list-wrapper"
                    v-else-if="subscribersList.length && subscriberSearch"
                >
                    <div
                        class="guest-item p-2"
                        :key="subscriber.id"
                        v-for="subscriber in subscribersList"
                        @click="selectSubscriber(subscriber.text, subscriber.value)"
                    >
                        <span>{{ subscriber.text }}</span>
                    </div>
                </div>
                <div
                    class="merge-guests-wrapper subscribers-list-wrapper"
                    v-else-if="!subscribersList.length && !!subscriberSearch && !selectedSubscriber"
                >
                    <div class="p-2">
                        <span class="text-center">Nothing found</span>
                    </div>
                </div>
                <div v-else />
            </div>
            <b-button-group class="d-lg-none d-block">
                <more-filters-dropdown>
                    <div class="merge-source-wrapper mb-0 subscribers-wrapper d-flex d-lg-none mr-1">
                        <form-input
                            id="source"
                            @input="(value) => searchSubscribers(value)"
                            :value="subscriberSearch"
                            placeholder="Search by subscriber"
                            autocomplete="off"
                            class="w-100"
                        />
                        <div class="merge-guests-wrapper subscribers-list-wrapper" v-if="!!subscriberSearch && busy">
                            <div class="guest-item p-2 d-flex align-items-center justify-content-center">
                                <b-spinner variant="primary" :small="true" />
                            </div>
                        </div>
                        <div
                            class="merge-guests-wrapper subscribers-list-wrapper"
                            v-else-if="subscribersList.length && subscriberSearch"
                        >
                            <div
                                class="guest-item p-2"
                                :key="subscriber.id"
                                v-for="subscriber in subscribersList"
                                @click="selectSubscriber(subscriber.text, subscriber.value)"
                            >
                                <span>{{ subscriber.text }}</span>
                            </div>
                        </div>
                        <div
                            class="merge-guests-wrapper subscribers-list-wrapper"
                            v-else-if="!subscribersList.length && !!subscriberSearch && !selectedSubscriber"
                        >
                            <div class="p-2">
                                <span class="text-center">Nothing found</span>
                            </div>
                        </div>
                        <div v-else />
                    </div>
                </more-filters-dropdown>
            </b-button-group>
        </grid>
    </page>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';
import API from '../../../api';
import { AI_REPORT_MESSAGE_ENDPOINT } from '../../../endpoints';
import Grid from '../../generic/grid/grid.vue';
import page from '../../generic/page/page.vue';
import FormInput from '../../generic/form-input/form-input.vue';
import ExportToExcelButton from '../../generic/export-to-excel-button/export-to-excel-button.vue';
import MoreFiltersDropdown from '../../generic/more-filters-dropdown/more-filters-dropdown.vue';
import VueApexCharts from 'vue3-apexcharts';
import Card from '../../generic/card/card.vue';
import ResponsiveDropdown from '../../generic/responsive-dropdown/responsive-dropdown.vue';
import UserActionsCellRenderer from './staylio-app-user-actions-cell-renderer.vue';
import { create } from 'lodash';

export default {
    components: {
        page,
        Grid,
        FormInput,
        ExportToExcelButton,
        MoreFiltersDropdown,
        VueApexCharts,
        Card,
        ResponsiveDropdown,
        userActionsCellRenderer: UserActionsCellRenderer,
    },
    name: 'LodgixAiReportMessages',
    data() {
        return {
            busy: false,
            dateRequestFormat: 'yyyy-MM-dd',
            rowStyle: null,
            subscribersList: [],
            usersList: [],
            selectedSubscriber: '',
            selectedUser: '',
            subscriberSearch: '',
            userSearch: '',
            offset: 0,
            limit: 20,
            sort: 'created',
            desc: false,
            showTable: true,
            chartData: null,
            filters: [
                { id: 'helpful', label: 'Helpful Feedback' },
                { id: 'unhelpful', label: 'Unhelpful Feedback' },
                { id: 'reported', label: 'Reported Messages' },
            ],
            selectedFilter: '',
            msgTypes: [{ id: 0, label: 'Reply' }, { id: 1, label: 'Note' }],
            selectedMsgType: '',
        };
    },
    computed: {
        ...mapGetters('header', ['userCurrencySymbol']),

        options() {
            return {
                chart: {
                    type: 'pie',
                    width: '100%',
                },
                labels: ['iOS', 'Android', 'Web'],
                legend: {
                    show: true,
                    position: 'bottom',
                },
            };
        },

        pinnedBottomRowData() {
            return [
                {
                    conversation: `Total Messages: ${this.chartData?.total || 0}`,
                    created: '',
                    is_ai_message_reported: `Reported: ${this.chartData?.total_reported || 0}`,
                    is_ai_helpful_feeback: `Helpful: ${this.chartData?.total_helpful || 0} | Unhelpful: ${this.chartData
                        ?.total_unhelpful || 0}`,
                    isPinnedRow: true,
                },
            ];
        },

        series() {
            return [0, 0, 0];
        },

        columnDefs() {
            return [
                {
                    field: 'conversation',
                    headerName: 'Conversation ID',
                    minWidth: 120,
                },
                {
                    field: 'id',
                    headerName: 'Message ID',
                    minWidth: 120,
                },
                {
                    field: 'created',
                    headerName: 'Sent At',
                    type: 'dateTimeColumn',
                },
                {
                    field: 'is_ai_message_reported',
                    headerName: 'Message Reported',
                    minWidth: 170,
                    cellRenderer: (params) => {
                        if (params.data.isPinnedRow) {
                            return params.value;
                        }
                        if (params.value === true) {
                            return 'Reported';
                        } else {
                            return '';
                        }
                    },
                },
                {
                    field: 'is_ai_helpful_feeback',
                    headerName: 'Guest Feedback',
                    minWidth: 150,
                    cellRenderer: (params) => {
                        if (params.data.isPinnedRow) {
                            return params.value;
                        }
                        if (params.value === true) {
                            return 'Helpful';
                        } else if (params.value === false) {
                            return 'Unhelpful';
                        } else {
                            return '';
                        }
                    },
                },
                {
                    field: 'type',
                    headerName: 'Message Type',
                    minWidth: 120,
                },
                {
                    field: 'guest',
                    headerName: 'Guest ID',
                    minWidth: 120,
                },
                {
                    field: 'subscriber',
                    headerName: 'Subscriber ID',
                    autoWidthExclude: true,
                },
                {
                    headerName: '',
                    minWidth: 100,
                    resizable: false,
                    sortable: false,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'userActionsCellRenderer',
                    cellRendererParams: {
                        refresh: this.refresh,
                    },
                },
            ];
        },
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                let is_ai_message_reported = null;
                let is_ai_helpful_feeback = null;

                if (this.selectedFilter === 'helpful') {
                    is_ai_helpful_feeback = true;
                } else if (this.selectedFilter === 'unhelpful') {
                    is_ai_helpful_feeback = false;
                } else if (this.selectedFilter === 'reported') {
                    is_ai_message_reported = true;
                }

                if (offset === 0) {
                    this.getTotals().then(({ data }) => {
                        this.chartData = data;
                    });
                }

                return API.get(`${AI_REPORT_MESSAGE_ENDPOINT()}grid/`, {
                    params: {
                        offset,
                        limit,
                        sort,
                        desc,
                        search,
                        subscriber: this.selectedSubscriber,
                        is_ai_message_reported,
                        is_ai_helpful_feeback,
                        type: this.selectedMsgType,
                    },
                });
            };
        },
        goBack() {
            return () => {
                this.showTable = !this.showTable;
                if (this.showTable) {
                    this.refresh();
                }
            };
        },

        filterDropdown() {
            const list = this.filters.map((item) => {
                return {
                    label: item.label,
                    click: () => {
                        this.selectedFilter = item.id;
                        this.refresh();
                    },
                };
            });
            list.unshift({
                label: 'No Filter',
                click: () => {
                    this.selectedFilter = '';
                    this.refresh();
                },
            });
            return list;
        },

        filterDropdownLabel() {
            return this.filters.find((item) => item.id === this.selectedFilter)?.label || 'No Filter';
        },

        msgTypeDropdown() {
            const list = this.msgTypes.map((item) => {
                return {
                    label: item.label,
                    click: () => {
                        this.selectedMsgType = item.id;
                        this.refresh();
                    },
                };
            });
            list.unshift({
                label: 'All Messages',
                click: () => {
                    this.selectedMsgType = '';
                    this.refresh();
                },
            });
            return list;
        },

        msgTypeDropdownLabel() {
            return this.msgTypes.find((item) => item.id === this.selectedMsgType)?.label || 'All Messages';
        },
    },
    mounted() {
        this.rowStyle = (params) => {
            if (params.node.rowPinned) {
                return { 'font-weight': 'bold' };
            }
        };
    },
    methods: {
        onSearchInput: debounce(function() {
            this.refresh();
        }, 500),
        async fetchSubscribers() {
            try {
                this.busy = true;
                const { data } = await API.get(`${AI_REPORT_MESSAGE_ENDPOINT()}subscribers/`, {
                    params: {
                        search: this.subscriberSearch,
                    },
                });
                this.subscribersList = data.map(({ user }) => ({
                    text: `${user.id} - ${user.email}`,
                    value: user.id,
                }));
            } catch (e) {
                this.errorToast({ text: 'Could not fetch subscribers' });
            } finally {
                this.busy = false;
            }
        },
        selectSubscriber(text, value) {
            this.subscriberSearch = text;
            this.selectedSubscriber = value;
            this.subscribersList = [];
            this.refresh();
        },
        searchSubscribers: debounce(function(value) {
            this.subscriberSearch = value;
            this.selectedSubscriber = '';
            if (value === '') {
                this.refresh();
            } else {
                this.fetchSubscribers();
            }
        }, 500),

        refresh() {
            if (this.showTable) {
                this.$refs.grid?.refreshDataSource();
            }
        },
        getTotals() {
            return API.get(`${AI_REPORT_MESSAGE_ENDPOINT()}totals/`, {
                params: {
                    subscriber: this.selectedSubscriber,
                    is_ai_message_reported: this.selectedFilter === 'reported' ? true : null,
                    is_ai_helpful_feeback:
                        this.selectedFilter === 'helpful' ? true : this.selectedFilter === 'unhelpful' ? false : null,
                    type: this.selectedMsgType,
                    search: this.search,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.subscribers-list-wrapper {
    top: 40px;
}
.subscribers-wrapper {
    min-width: 300px;
}
</style>
